
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { validateFields } from '@utils/helper';
import { Button, Input, Form, Row, Col, Spin, Checkbox } from 'antd';
import BankList from '@common/BankList';
import './style.less';

function UserDetail({ user, onSave, onCancel, form }) {
  const { getFieldDecorator } = form;
  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])
  const { isLoading, mutate: saveUser } = useMutation((data) => {
    if (user.id) {
      return request.put(`v1/users/${user.id}`, data);
    }
    return request.post(`v1/users`, data);
  },
    {
      onSuccess: (response) => {
        onSave();
        form.resetFields();
      },
    });

  const handleUpdateBasicSalary = () => {
    const { getFieldValue, setFieldsValue } = form;
    const basicSalary = getFieldValue('basicSalary');
    if(basicSalary != user.basicSalary){
      const overtimeFeePerHour = Math.floor(parseInt(basicSalary)/26/8*1.5);
      setFieldsValue({
        overtimeFeePerHour
      })
    }
  };
  const handleReset = () => {
    onCancel({});
    form.resetFields();
  }
  const handleSubmit = async e => {
    e.preventDefault();
    const [err, values] = await validateFields(form);
    if (!err) {
      const postData = {
        ...values,
      }
      saveUser(postData);
    }
  }
  return (
    <Spin spinning={isLoading}>
      <Form className='UserDetail' onSubmit={handleSubmit}>
        <Row gutter={8}>
          <Col sm={12}>
            <Form.Item label="Họ tên">
              {getFieldDecorator('name', {
                initialValue: user.name || ''
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col sm={6}>
            <Form.Item label="Điện thoại">
              {getFieldDecorator('phone', {
                initialValue: user.phone || ''
              })(<Input />)
              }
            </Form.Item>
          </Col>
          <Col sm={6}>
            <Form.Item label="Bậc lương">
              {getFieldDecorator('salaryRange', {
                initialValue: user.salaryRange || ''
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col sm={6}>
            <Form.Item label="Active">
              {getFieldDecorator('active', {
                valuePropName: 'checked',
                initialValue: user.active ? true : false
              })(<Checkbox />)}
            </Form.Item>
          </Col>
          <Col sm={18}>
            <Form.Item label="Avatar">
              {getFieldDecorator('avatar', {
                initialValue: user.avatar || ''
              })(<Input />)
              }
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col sm={12}>
            <Form.Item label="Ngân Hàng">
              {getFieldDecorator('bankName', {
                initialValue: user.bankName || ''
              })(<BankList size="default" />)
              }
            </Form.Item>
          </Col>
          <Col sm={12}>
            <Form.Item label="Số TK">
              {getFieldDecorator('bankAccount', {
                initialValue: user.bankAccount || ''
              })(<Input />)
              }
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col sm={6}>
            <Form.Item label="Lương căn bản">
              {getFieldDecorator('basicSalary', {
                initialValue: user.basicSalary || '0'
              })(<Input 
                onBlur={handleUpdateBasicSalary}
              />)
              }
            </Form.Item>
          </Col>
          <Col sm={6}>
            <Form.Item label="Phụ cấp">
              {getFieldDecorator('allowance', {
                initialValue: user.allowance || '0'
              })(<Input />)
              }
            </Form.Item>
          </Col>
          <Col sm={6}>
            <Form.Item label="Lương OT">
              {getFieldDecorator('overtimeFeePerHour', {
                initialValue: user.overtimeFeePerHour || '0'
              })(<Input />)
              }
            </Form.Item>
          </Col>
          <Col sm={6}>
            <Form.Item label="Tiền cơm">
              {getFieldDecorator('lunchPerDay', {
                initialValue: user.lunchPerDay || '0'
              })(<Input />)
              }
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col sm={24}>
            <Form.Item label="Ghi chú">
              {getFieldDecorator('note', {
                initialValue: user.note || ''
              })(<Input />)
              }
            </Form.Item>
          </Col>
          <Col sm={24}>
            <Button style={{ marginTop: 28 }} type='primary' onClick={handleSubmit}>{user.id ? 'Cập nhật' : 'Lưu'}</Button>
            <Button style={{ marginTop: 28, marginLeft: 20 }} onClick={handleReset}>{'Đóng'}</Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  )
}

UserDetail.propTypes = {
  form: PropTypes.object,
  user: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};

UserDetail.defaultProps = {
  form: {},
  user: {},
  onSave: () => { },
  onCancel: () => { }
};

export default Form.create()(UserDetail);
